export default __webpack_public_path__ + "static/bg-3-70004963eb3c23b1f7d6f585dab45dea.png";